import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const LeadContact = ApplicationRecord.extend({
  attrs: {
    email: attr({ type: String }),
    first_name: attr({ type: String }),
    last_name: attr({ type: String }),
    postcode: attr({ type: String }),
    first_delivery_date: attr({ type: String }),
    meal_plan: attr({ type: String }),
    selected_recipes_ids: attr({ type: Array }),
    phone_number: attr({ type: String }),
    source: attr({ type: String }),
    portion_count_per_meal: attr({ type: Number }),
    marketing_opt_in: attr({ type: Boolean }),
    street_1: attr({ type: String }),
    street_2: attr({ type: String }),
    delivery_instructions: attr({ type: String }),
    voucher_code_used: attr({ type: String }),
    partnership_name: attr({ type: String }),
  },
  static: {
    endpoint: '/lead_contacts',
    jsonapiType: 'lead_contacts-lead_contacts',
  },
});

export default LeadContact;
